var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLinesCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 26.727",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;stroke:#101820;stroke-miterlimit:10;stroke-width:2px;}.b{stroke-linecap:square;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 16,
    transform: "translate(0 8.727)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 11.709,
    transform: "translate(0 5.091)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.818,19.745v5.163H2V6H23.818v4.364",
    transform: "translate(-2 -6)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 4.364,
    transform: "translate(4.363 13.817)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M28.363,22.182a5.835,5.835,0,0,1-5.818-5.818H19.636A4.376,4.376,0,0,1,15.273,12H25.381a10.182,10.182,0,1,1,.073,20.363,126.343,126.343,0,0,1-13.309-1.091A4.322,4.322,0,0,1,8.582,28.29L8,26.545",
    transform: "translate(-3.637 -7.637)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinesCard);
export default __webpack_public_path__ + "static/media/Icon_Lines_Card.725d82f0cafb09ed89ae7872ac417bc2.svg";
export { ForwardRef as ReactComponent };